import React, { useState } from 'react';
import {
  Box,
  TextField,
  MenuItem,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Slider,
} from '@mui/material';

const QUESTION_TYPES = [
  { value: 'text', label: 'Text Input' },
  { value: 'radio', label: 'Multiple Choice (Single)' },
  { value: 'checkbox', label: 'Multiple Choice (Multiple)' },
  { value: 'slider', label: 'Slider' },
];

function QuestionBox() {
  const [questionText, setQuestionText] = useState('');
  const [answerType, setAnswerType] = useState('');
  const [options, setOptions] = useState([]);
  const [newOption, setNewOption] = useState('');

  const handleAddOption = () => {
    if (newOption.trim()) {
      setOptions([...options, newOption]);
      setNewOption('');
    }
  };

  return (
    <Box
      p={3}
      border="1px solid #ccc"
      borderRadius={2}
      width="100%"
      maxWidth={600}
      mx="auto"
      mt={5}
    >
      <TextField
        fullWidth
        label="Enter your question"
        value={questionText}
        onChange={(e) => setQuestionText(e.target.value)}
        margin="normal"
      />

      <TextField
        select
        fullWidth
        label="Select Answer Type"
        value={answerType}
        onChange={(e) => {
          setAnswerType(e.target.value);
          setOptions([]); // reset options when type changes
        }}
        margin="normal"
      >
        {QUESTION_TYPES.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>

      {['radio', 'checkbox'].includes(answerType) && (
        <Box mt={2}>
          <Box display="flex" gap={1} mb={1}>
            <TextField
              label="New Option"
              value={newOption}
              onChange={(e) => setNewOption(e.target.value)}
              size="small"
            />
            <Button onClick={handleAddOption} variant="contained">
              Add Option
            </Button>
          </Box>

          {answerType === 'radio' && (
            <RadioGroup>
              {options.map((opt, idx) => (
                <FormControlLabel
                  key={idx}
                  value={opt}
                  control={<Radio />}
                  label={opt}
                />
              ))}
            </RadioGroup>
          )}

          {answerType === 'checkbox' && (
            <Box>
              {options.map((opt, idx) => (
                <FormControlLabel
                  key={idx}
                  control={<Checkbox />}
                  label={opt}
                />
              ))}
            </Box>
          )}
        </Box>
      )}

      {answerType === 'text' && (
        <TextField
          fullWidth
          label="User Response"
          placeholder="User will enter text here"
          disabled
          margin="normal"
        />
      )}

      {answerType === 'slider' && (
        <Box mt={3}>
          <Slider defaultValue={50} valueLabelDisplay="auto" />
        </Box>
      )}
    </Box>
  );
}

export default QuestionBox;
